import defaultStrategy from './default-login';
import zuzucheStrategy from './zuzuche-login';
import travelStrategy from './travel-login';
import mapStrategy from './map-login';
import miniProgramStrategy from './miniprogram-login';

const loginStrategy = {
  tantutravel: travelStrategy,
  tantumap: mapStrategy,
  zuzuche: zuzucheStrategy,
  miniprogram: miniProgramStrategy
};

export function strategyFactory(browser) {
  return loginStrategy[browser] ? loginStrategy[browser] : defaultStrategy;
}
